import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Hyperlink, Notification } from '@offerzen/pinata-shame'
import BareBonesNavbar from '../../components/BareBonesNavbar'
import Container from '../../components/Container'

const HomeScene = ({ candidateProfileId }) => {
  return (
    <>
      <BareBonesNavbar />
      <Container>
        <h1>Candidate Experience a.k.a. Ax 🪓</h1>
        <p>
          ℹ️ You are currently <strong>{candidateProfileId ? 'logged in' : 'logged out'}</strong>.
        </p>

        <p>Logged in views:</p>
        <ul>
          <li>
            <Hyperlink label="Dashboard" href={`/candidate/${candidateProfileId}/dashboard`} as={Link} />
          </li>
          <li>
            <Hyperlink label="Profile" href={`/candidate/${candidateProfileId}/profile`} as={Link} />
          </li>
          <li>
            <Hyperlink label="Interviews" href={`/candidate/${candidateProfileId}/interview_requests`} as={Link} />
          </li>
        </ul>
        <p>Onboarding views:</p>
        <ul>
          <li>
            <Hyperlink label="Onboarding (first step)" href={`/candidate/${candidateProfileId}/resume`} as={Link} />
          </li>
        </ul>
        <p>Logged out views:</p>
        <ul>
          <li>
            <Hyperlink label="Sign up" href="/candidate/signup" as={Link} />
          </li>
        </ul>
        <Notification theme="info">This page is only visible in non-production environments.</Notification>
      </Container>
    </>
  )
}

HomeScene.propTypes = {
  candidateProfileId: PropTypes.string,
}

export default HomeScene
